import { render, staticRenderFns } from "./mall-list.vue?vue&type=template&id=9a4a9476&scoped=true"
import script from "./mall-list.vue?vue&type=script&lang=js"
export * from "./mall-list.vue?vue&type=script&lang=js"
import style0 from "./mall-list.vue?vue&type=style&index=0&id=9a4a9476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4a9476",
  null
  
)

export default component.exports